import React from "react"

import logoFooterImage from "../../images/logo-footer.png";
import { Link } from "gatsby";

const Footer = () => (
  <footer className="c-footer">
    <div className="c-footer__content">

      <div className="c-footer__grid">

        <img className="c-footer__logo" src={logoFooterImage} alt="Logo" />

        <div className="c-footer__text">
          <div className="c-text--yellow">Edmonton, AB</div>
          <div>9620 174 Street — T5T 6B9</div>
          <div><a className="c-text--link" href="tel:+5875667198">(587) 566-7198</a></div>
          <div><a className="c-text--link" href="mailto:albertau@auetchiu.com">albertau@auetchiu.com</a></div>
        </div>

        <ul className="c-footer__nav">
          <li><Link className="c-footer__link" activeClassName="is-active" to="/">home</Link></li>
          <li><Link className="c-footer__link" activeClassName="is-active" to="/products">products</Link></li>
          <li><Link className="c-footer__link" activeClassName="is-active" to="/contact">contact</Link></li>
        </ul>

        <Link className="c-text--light c-text--link c-footer__privacy" to="/privacy">Privacy Policy</Link>
      </div>

      <iframe className="c-footer__map" title="Map" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d592.8488249169675!2d-113.6257786782112!3d53.532855706864815!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x53a020f99b6259ed%3A0x2aa8698f7d7e0255!2s9620%20174%20St%20NW%2C%20Edmonton%2C%20AB%20T5T%206B9!5e0!3m2!1sen!2sca!4v1597464058102!5m2!1sen!2sca" width="600" height="450" frameBorder="0" allowFullScreen={false} aria-hidden="false" />
    </div>
  </footer>
)

export default Footer